const socialStreamModule = document.querySelector("[data-js-module='o-social-stream']");
const socialStreamModuleStartseite = document.querySelector(
  "[data-js-module='o-social-stream-startseite']"
);

if (socialStreamModule) {
  const doc = document;
  const scriptTag = doc.createElement('script');
  const firstScriptTag = doc.getElementsByTagName('script')[0];

  scriptTag.async = 1;
  scriptTag.src = 'https://cdn.curator.io/published/81eec910-c8c0-483b-873e-5687118c30e6.js';

  firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
}

if (socialStreamModuleStartseite) {
  const doc = document;
  const scriptTag = doc.createElement('script');
  const firstScriptTag = doc.getElementsByTagName('script')[0];

  scriptTag.async = 1;
  scriptTag.src = 'https://cdn.curator.io/published/5054c495-2d35-40a9-91df-9374157b7a12.js';

  firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
}
